import axios from "axios";
import config from "services/config";

const BASE = `${config.url}/accountant/recommendations`;

function adminHeaders() {
  return { Authorization: `Basic ${process.env.REACT_APP_BASIC_AUTH}` };
}

export const RecommendationsService = {
  // CRUD por cliente
  async list(memberId, { status, module: mod } = {}) {
    const { data } = await axios.get(`${BASE}/${memberId}`, { params: { status, module: mod }, headers: adminHeaders() });
    return data;
  },
  async get(memberId, id) {
    const { data } = await axios.get(`${BASE}/${memberId}/${id}`, { headers: adminHeaders() });
    return data;
  },
  async create(memberId, payload) {
    const { data } = await axios.post(`${BASE}/${memberId}`, payload, { headers: adminHeaders() });
    return data;
  },
  async update(memberId, id, payload) {
    const { data } = await axios.patch(`${BASE}/${memberId}/${id}`, payload, { headers: adminHeaders() });
    return data;
  },
  async remove(memberId, id) {
    const { data } = await axios.delete(`${BASE}/${memberId}/${id}`, { headers: adminHeaders() });
    return data;
  },
  async publish(memberId, id) {
    const { data } = await axios.post(`${BASE}/${memberId}/${id}/publish`, {}, { headers: adminHeaders() });
    return data;
  },
  async archive(memberId, id) {
    const { data } = await axios.post(`${BASE}/${memberId}/${id}/archive`, {}, { headers: adminHeaders() });
    return data;
  },
  async fromTemplate(memberId, templateId) {
    const { data } = await axios.post(`${BASE}/${memberId}/from-template/${templateId}`, {}, { headers: adminHeaders() });
    return data;
  },

  // Plantillas
  async listTemplates() {
    const { data } = await axios.get(`${BASE}/templates`, { headers: adminHeaders() });
    return data;
  },
  async createTemplate(payload) {
    const { data } = await axios.post(`${BASE}/templates`, payload, { headers: adminHeaders() });
    return data;
  },
  async updateTemplate(id, payload) {
    const { data } = await axios.patch(`${BASE}/templates/${id}`, payload, { headers: adminHeaders() });
    return data;
  },
  async removeTemplate(id) {
    const { data } = await axios.delete(`${BASE}/templates/${id}`, { headers: adminHeaders() });
    return data;
  },
};
